import React from 'react';
import { BsBox, BsCheckCircle, BsExclamationCircle, BsFileText, BsList } from 'react-icons/bs';

interface FooterProps {
  currentView: 'details' | 'orders' | 'picklist';
  onViewChange: (view: 'details' | 'orders' | 'picklist') => void;
  hasPickedItems: boolean;
  allCompleted: boolean;
  totalRequiredQty: number;
  totalPickedQty: number;
  onCompleteOrder: () => void;
}

export const Footer: React.FC<FooterProps> = ({
  currentView,
  onViewChange,
  hasPickedItems,
  allCompleted,
  totalRequiredQty,
  totalPickedQty,
  onCompleteOrder
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-300 shadow-lg z-20">
      {/* {!hasPickedItems && (
        <div className="bg-blue-50 border-b border-blue-300 py-2">
          <div className="max-w-4xl mx-auto px-4">
            <p className="text-blue-700 font-semibold text-sm md:text-base text-right">
              ℹ️ Beginnen Sie mit der Kommissionierung
            </p>
          </div>
        </div>
      )}
      
      {!allCompleted && hasPickedItems && (
        <div className="bg-orange-50 border-b border-orange-300 py-2">
          <div className="max-w-4xl mx-auto px-4">
            <p className="text-orange-700 font-semibold flex items-center gap-2 text-sm md:text-base justify-end">
              <span>Es fehlen {totalRequiredQty - totalPickedQty} von {totalRequiredQty} Stück</span>
              <BsExclamationCircle size={18} />
            </p>
          </div>
        </div>
      )}
      
      {allCompleted && (
        <div className="bg-green-50 border-b border-green-300 py-2">
          <div className="max-w-4xl mx-auto px-4">
            <p className="text-green-700 font-semibold flex items-center gap-2 text-sm md:text-base justify-end">
              <span>Alle {totalRequiredQty} Stück erfasst</span>
              <BsCheckCircle size={18} />
            </p>
          </div>
        </div>
      )}
       */}
      <div className="max-w-4xl mx-auto flex">
        <button
          onClick={() => onViewChange('details')}
          className={`flex-1 py-3 md:py-4 flex flex-col items-center justify-center gap-1 transition ${
            currentView === 'details' 
              ? 'bg-blue-100 text-blue-600' 
              : 'text-gray-600 hover:bg-gray-50'
          }`}
        >
          <BsFileText size={20} className="md:w-6 md:h-6" />
          <span className="text-[10px] md:text-xs font-semibold">Details</span>
        </button>
        
        <button
          onClick={() => onViewChange('orders')}
          className={`flex-1 py-3 md:py-4 flex flex-col items-center justify-center gap-1 transition ${
            currentView === 'orders' 
              ? 'bg-blue-100 text-blue-600' 
              : 'text-gray-600 hover:bg-gray-50'
          }`}
        >
          <BsBox size={20} className="md:w-6 md:h-6" />
          <span className="text-[10px] md:text-xs font-semibold">Aufträge</span>
        </button>
        
        <button
          onClick={() => onViewChange('picklist')}
          className={`flex-1 py-3 md:py-4 flex flex-col items-center justify-center gap-1 transition ${
            currentView === 'picklist' 
              ? 'bg-blue-100 text-blue-600' 
              : 'text-gray-600 hover:bg-gray-50'
          }`}
        >
          <BsList size={20} className="md:w-6 md:h-6" />
          <span className="text-[10px] md:text-xs font-semibold">Pickliste</span>
        </button>
        
        <button
          onClick={onCompleteOrder}
        //   disabled={!hasPickedItems}
          className={`flex-1 py-3 md:py-4 flex flex-col items-center justify-center gap-1 transition ${
            !hasPickedItems
              ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
              : allCompleted
                ? 'bg-green-500 text-white hover:bg-green-600'
                : 'bg-orange-400 text-white hover:bg-orange-500'
          }`}
        >
          <BsCheckCircle size={20} className="md:w-6 md:h-6" />
          <span className="text-[10px] md:text-xs font-semibold">
            {!hasPickedItems
              ? 'Abschließen'
              : allCompleted 
                ? 'Abschließen'
                : 'Teillieferung'}
          </span>
        </button>
      </div>
    </div>
  );
};